module.exports = __webpack_public_path__ + "img/UnionPay_logo.svg.26596789.png";